import { t } from 'i18next';
import { AppTableFilters } from '../../services/AppTableFilters';
import { createFilter, getFilterOptions } from "../../components/Tables/ColumnCreationHelper";
import { SingleUserType } from 'types/GlobalTypes';

export const appTableFiltersInstance = new AppTableFilters();

export const usersTableColumns = (data: SingleUserType[]) => [
  {
    id: 'email',
    Header: t('table.email'),
    accessor: 'email',
    maxWidth: 100,
    filter: createFilter(appTableFiltersInstance, 'textfields', 'email', t('table.email'))
  },
  {
    id: 'firstName',
    Header: t('table.firstName'),
    accessor: 'firstName',
    maxWidth: 80,
    filter: createFilter(appTableFiltersInstance, 'textfields', 'firstName', t('table.firstName'))
  },
  {
    id: 'lastName',
    Header: t('table.lastName'),
    accessor: 'lastName',
    maxWidth: 80,
    filter: createFilter(appTableFiltersInstance, 'textfields', 'lastName', t('table.lastName'))
  },
  {
    id: 'roleName',
    Header: t('table.type'),
    accessor: 'roleName',
    maxWidth: 80,
    filter: createFilter(appTableFiltersInstance, 'select', 'roleName', t('table.type'), (columnName) => getFilterOptions(data, columnName))
  },
  {
    id: 'userId',
    Header: t('table.userId'),
    accessor: 'id',
    maxWidth: 80,
    filter: createFilter(
      appTableFiltersInstance,
      'textfields',
      'userId',
      t('table.userId'),
      undefined,
      undefined,
      'id'
    )
  },
  {
    id: 'actions',
    Header: t('table.actions'),
    maxWidth: 80,
  },
];
